// Section for import npm components -----------------------------------------------------------------------------------
import React from 'react';

// Material UI ( mui ) components
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
// Section for import custom components --------------------------------------------------------------------------------

// Section for render component ----------------------------------------------------------------------------------------

// Section for type definition -----------------------------------------------------------------------------------------
import MansionShopPropsData from '@/types/components/MansionDetail/MansionShopPropsData';

type MansionShopProps = {
  shop: MansionShopPropsData[];
};

export default function MansionShop(props: MansionShopProps) {
  const { shop } = props;
  return (
    <Box className="md:max-w-7xl md:w-full mx-auto max-md:mx-0 mt-16 max-md:mt-12 mb-16 max-md:mb-10 pl-24 max-md:px-5">
      <Box>
        <Typography
          variant="h2"
          className="border-solid border-l-2 border-rf-black relative  mb-6 pl-4 text-lg font-bold before:absolute before:top-1 before:left-[-16px] max-md:before:left-0"
        >
          この地域のおすすめ店舗
        </Typography>
      </Box>

      <Box className="shops-info-slider-group flex gap-x-4">
        {shop.map((shopData) => (
          <Box
            key={shopData.id}
            className="shops-info-slider-card relative md:flex md:gap-x-7 px-7 max-md:px-4 py-6 max-md:py-5 w-[760px] max-md:w-[265px] border-solid border-gray-02 border-[1px] shadow-none rounded-lg"
          >
            <Box className="max-md:hidden">
              <img
                src={shopData.shopLogoUrl}
                alt={shopData.companyName}
                className="w-[232px] h-[140px] rounded-2xl  aspect-video object-cover"
              />
            </Box>
            <Box className="md:w-[444px]">
              <Box>
                <Typography variant="h3" className="max-md:pb-3 text-sm font-bold text-rf-black">
                  {shopData.fcShopName}
                </Typography>
                <img
                  src={shopData.shopLogoUrl}
                  alt={shopData.companyName}
                  className="md:hidden w-full h-64 max-md:h-[140px] rounded-2xl max-md:rounded-md aspect-video object-cover"
                />
                <Box className="flex flex-wrap gap-x-3 gap-y-2 text-rf-black mt-4 max-md:mt-3">
                  {shopData.isRenovationHistory && (
                    <Box className="px-4 py-1 text-xs bg-gray-01 rounded">リノベ実績あり</Box>
                  )}
                  {shopData.isContractHistory && (
                    <Box className="px-4 py-1 text-xs bg-gray-01 rounded">仲介実績あり</Box>
                  )}
                </Box>
                <Box className="flex mt-4">
                  <Typography className="min-w-[60px] text-xs text-gray-04 font-bold">住所</Typography>
                  <Typography className="text-xs">{shopData.shopAddress}</Typography>
                </Box>
                <Box className="flex flex-wrap gap-y-1 mt-3 max-md:mt-2">
                  <Typography className="w-[60px] text-xs text-gray-04 font-bold">電話</Typography>
                  <Typography className="text-xs">{shopData.shopTel}</Typography>
                </Box>
              </Box>
              <Box className="mt-6 max-md:mt-4 md:flex md:gap-x-5">
                {shopData.comFcShopUrl && (
                  <Button
                    href={shopData.comFcShopUrl}
                    target="_blank"
                    className="group relative w-[233px] h-12 bg-rf-black md:hover:bg-rf-yellow text-sm text-white md:hover:text-rf-black font-bold"
                    endIcon={
                      <ArrowForwardRoundedIcon className="absolute right-3 top-[15px] md:group-hover:text-rf-black" />
                    }
                  >
                    詳細を見る
                  </Button>
                )}
                {shopData.comFcShopInquiryUrl && (
                  <Button
                    href={shopData.comFcShopInquiryUrl}
                    target="_blank"
                    className="group relative max-md:mt-4 w-[233px] h-12 bg-rf-black md:hover:bg-rf-yellow text-sm text-white md:hover:text-rf-black font-bold"
                    endIcon={
                      <ArrowForwardRoundedIcon className="absolute right-3 top-[15px] md:group-hover:text-rf-black" />
                    }
                  >
                    お問い合わせ
                  </Button>
                )}
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
